/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { AiOutlineRight, AiOutlineLeft } from "react-icons/ai";
import usePagination from "./usePagination";

// eslint-disable-next-line import/no-anonymous-default-export
export default function (props) {
    //const [page, setPage] = useState("");
    const pgArray = Array.from(Array(props.pageSize).keys());
    const newArr = pgArray.map((pg) => pg - 1);

    const { next, prev, jump, currentData, currentPage, maxPage } =
        usePagination(props?.data, 2);

    //props.onChangeSomeState(1);

    // useEffect(() => {
    //     // props.setSlicedData(currentData());
    //     props.onChangeSomeState("test");
    // }, []);

    // console.log(pgArray);
    // console.log(newArr);
    // console.log(currentPage);
    //console.table(currentData());

    return (
        <div className={`${props.className} flex justify-center`}>
            <div className="border-[.1rem] border-light-prim2 w-auto inline-flex rounded-[1rem]  items-center h-[3.8rem]">
                <a
                    style={{ pointerEvents: currentPage == 0 && "none" }}
                    onClick={() => prev()}
                    title="prev"
                    className="text-gray text-[1.2rem] flex items-center h-full px-[0.8rem] border-l-solid	border-l-light-prim2 border-l-[0.1rem] cursor-pointer hover:rounded-r-[1rem] hover:bg-purple-dark-1 hover:text-light-prim1"
                >
                    <AiOutlineRight className="text-[1rem] text-gray ml-[1.3rem] " />
                    قبلی
                </a>
                {newArr.map((i) => {
                    return [
                        <div
                            className={
                                currentPage === i
                                    ? "text-light-prim1 text-[1.2rem] bg-purple-dark-1 border-l-light-prim2  border-l-[.1rem] py-[.9rem] px-[1.7rem] border-l-solid cursor-pointer pt-[.8rem] pb-[.8rem] w-[4rem] h-full flex items-center hover:bg-purple-dark-1 hover:text-light-prim1 delay-[10ms] transition focus:border-none"
                                    : "text-light-gray text-[1.2rem]  px-[1.7rem] border-l-solid	 border-l-[.1rem] border-l-light-prim2 cursor-pointer w-[4rem] h-full flex items-center hover:bg-purple-dark-1 hover:text-light-prim1 delay-[10ms] transition focus:border-none"
                            }
                            Value={i}
                            key={i}
                            onClick={() => {
                                jump(i);
                                console.log("jumped");
                            }}
                        >
                            {i + 1}
                        </div>,
                    ];
                })}
                <a
                    style={{
                        pointerEvents: currentPage == props.pageSize && "none",
                    }}
                    onClick={() => next()}
                    title="next"
                    className="text-gray text-[1.2rem] flex items-center h-full px-[0.8rem] cursor-pointer hover:bg-purple-dark-1 hover:rounded-l-[1rem] hover:text-light-prim1"
                >
                    بعدی
                    <AiOutlineLeft className="text-[1rem] text-gray mr-[1.3rem]" />
                </a>
            </div>
        </div>
    );
}
